<template>
  <div class="app-container" style="border:none">
    <list ref="list"></list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
// import list from "@/components/sys/role/list";
import list from "@/components/business/sales/strategy/list";


export default {
  name: "strategy",
  mixins: [curdMixins],
  components: {
    list,

  },

};
</script>